// Mock data for Python, AI & Agentic Systems Course

export const mockRegistrations = [];

export const submitRegistration = (data) => {
  const registration = {
    id: Date.now().toString(),
    ...data,
    timestamp: new Date().toISOString()
  };
  mockRegistrations.push(registration);
  console.log('Registration submitted (mock):', registration);
  return { success: true, data: registration };
};

export const courseData = {
  title: "Python, AI & Agentic Systems Training for College Students",
  subtitle: "Learn Programming, Artificial Intelligence, and Agentic System Development in 3 Months",
  price: "9999",
  duration: "3 Months",
  
  about: "This 3-month program helps college students build strong programming foundations with Python and gain hands-on experience in AI, Machine Learning, and Agentic Systems. Includes internship opportunities, corporate mentor guidance, and career support.",
  
  pythonCurriculum: [
    {
      week: 1,
      title: "Python Fundamentals",
      topics: ["Basics", "Syntax", "Variables", "Data Types", "Input/Output"]
    },
    {
      week: 2,
      title: "Control Flow & Loops",
      topics: ["Conditions", "Loops", "Logic Building Exercises"]
    },
    {
      week: 3,
      title: "Data Structures",
      topics: ["Lists", "Tuples", "Sets", "Dictionaries", "Comprehensions"]
    },
    {
      week: 4,
      title: "Functions & Modules",
      topics: ["Defining Functions", "Lambda", "Importing Modules"]
    },
    {
      week: 5,
      title: "Files, Exceptions & OOP",
      topics: ["File Handling", "Error Handling", "Classes & Objects"]
    },
    {
      week: 6,
      title: "Python for AI",
      topics: ["Numpy", "Pandas", "Matplotlib", "Simple ML Model"]
    }
  ],
  
  aiCurriculum: [
    {
      week: 7,
      title: "Introduction to AI",
      topics: ["History", "Types of AI", "Intelligent Agents", "Rule-based Demo"]
    },
    {
      week: 8,
      title: "Machine Learning Basics",
      topics: ["Supervised Learning", "Unsupervised Learning", "Scikit-learn Project"]
    },
    {
      week: 9,
      title: "Deep Learning Concepts",
      topics: ["Neural Networks", "CNN/RNN Overview", "MNIST Project"]
    },
    {
      week: 10,
      title: "LLMs & Prompt Engineering",
      topics: ["Tokenization", "Prompts", "OpenAI/Hugging Face APIs"]
    },
    {
      week: 11,
      title: "Agentic Systems & Automation",
      topics: ["Planning", "Reasoning", "Memory", "Multi-agent Setups"]
    },
    {
      week: 12,
      title: "Capstone Project",
      topics: ["AI Study Buddy", "Smart Solar Advisor", "Campus Chatbot"]
    }
  ],
  
  highlights: [
    {
      title: "Internship Opportunities",
      description: "Get real-world experience through internship placements",
      icon: "briefcase"
    },
    {
      title: "Corporate Mentor Guidance",
      description: "Learn from experienced industry professionals",
      icon: "users"
    },
    {
      title: "Real-world Projects",
      description: "Build portfolio-worthy projects that matter",
      icon: "code"
    },
    {
      title: "Affordable Fee: ₹9999",
      description: "Quality education at an accessible price",
      icon: "tag"
    },
    {
      title: "3-Month Certified Training",
      description: "Complete certification upon successful completion",
      icon: "award"
    },
    {
      title: "Hands-on Learning",
      description: "60% Practical, 40% Theory approach",
      icon: "activity"
    }
  ],
  
  internshipDetails: {
    title: "Internship & Career Support",
    description: "Our program includes dedicated internship opportunities to help you gain real-world experience. Work on live projects, collaborate with teams, and build your professional network.",
    benefits: [
      "Guaranteed internship placement assistance",
      "Work on real industry projects",
      "Build professional portfolio",
      "Resume building and interview preparation",
      "Career counseling and guidance"
    ]
  },
  
  mentorshipDetails: {
    title: "Learn from Corporate Mentors",
    description: "Get personalized guidance from experienced professionals working in top tech companies. Our mentors provide project reviews, career advice, and placement preparation support.",
    features: [
      "Weekly mentorship sessions",
      "Project code reviews",
      "Career guidance and planning",
      "Industry insights and trends",
      "Placement preparation support"
    ]
  },
  
  tools: ["VS Code", "Jupyter", "GitHub", "Hugging Face", "LangChain"]
};
